import React from "react";

export default function NotFoundComman({ title, description, img }) {
  return (
    <div className="notFoundMessage">
      <img src={img} alt="" />
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  );
}
